import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
const EMPTY_DRAFTS = [];
export const useDrafts = function useDrafts() {
    let { refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.Drafts
        ],
        queryFn: ()=>api.draft.getSummaries(),
        refreshOnHookMount
    });
    return {
        drafts: data !== null && data !== void 0 ? data : EMPTY_DRAFTS,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
